module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Picnic-At-Hanging-Rock-S1.714ea4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Picnic-At-Hanging-Rock-S1.jpg
// module id = HBSP
// module chunks = 0